/**
 * BetaBanner — shown only for an explicitly opted-in local development build.
 */

export const BETA_MODE =
  import.meta.env.DEV && import.meta.env.VITE_BETA_MODE === "true";

/**
 * Height of the beta banner in pixels: py-1.5 (6px × 2) + text-xs line-height (16px) = 28px.
 * Import this wherever a fixed/sticky element needs to avoid sitting under the banner.
 */
export const BANNER_HEIGHT_PX = 28;

export default function BetaBanner() {
  if (!BETA_MODE) return null;
  return (
    <div
      role="status"
      className="w-full bg-amber-500 text-amber-950 text-center text-xs font-semibold py-1.5 px-4 z-50 sticky top-0"
    >
      🧪 Beta Access — All features unlocked for testing. Feedback welcome!
    </div>
  );
}
